import { render, staticRenderFns } from "./FlashcardsButton.vue?vue&type=template&id=573bd9e0"
import script from "./FlashcardsButton.vue?vue&type=script&lang=js"
export * from "./FlashcardsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports